// extracted by mini-css-extract-plugin
export default {"content":"style_content__qM-dJ","spinLoader":"style_spinLoader__JhrZV","checkbox":"style_checkbox__4atL2"};